import React from "react";
import {Pane} from "evergreen-ui";
import RainFloodPage from "./RainFloodPage";

export default function ConstructorRainFlood() {

    return (
        <Pane margin={40}>
            <RainFloodPage isFullInfo={false} isEdit={false}/>
        </Pane>
    );
}